import React, { useState, useEffect } from 'react';
import { DatePicker, Checkbox } from 'antd';
import dayjs from 'dayjs';
import { mdiCalendarMonth } from '@mdi/js';
import Icon from '@mdi/react';
import './style.css';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import useQueryParams from 'hooks/useQueryParams';

const RangePickerComponent = (props) => {
  const { RangePicker } = DatePicker;
  const {
    value = [],
    date_key = 'global',
    onChange,
    globalDate = true,
    placeholder = ['Start date', 'End date'],
    ...rest
  } = props;
  const { date_from, date_to, setDate } = useWidgetDate(date_key);
  const { setUrlParams } = useQueryParams();
  const [changeGlobal, setChangeGlobal] = useState(globalDate);
  const [formattedValue, setFormattedValue] = useState([
    date_from ? dayjs(date_from) : null,
    date_to ? dayjs(date_to) : null,
  ]);

  useEffect(() => {
    setFormattedValue([date_from ? dayjs(date_from) : null, date_to ? dayjs(date_to) : null]);
  }, [date_from, date_to]);

  const rangePresets = [
    { label: 'Today', value: [dayjs().startOf('day'), dayjs().endOf('day')] },
    {
      label: 'Yesterday',
      value: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')],
    },
    { label: 'This Week', value: [dayjs().startOf('week'), dayjs().endOf('week')] },
    {
      label: 'Last Week',
      value: [
        dayjs().subtract(1, 'week').startOf('week'),
        dayjs().subtract(1, 'week').endOf('week'),
      ],
    },
    { label: 'This Month', value: [dayjs().startOf('month'), dayjs().endOf('month')] },
    {
      label: 'Last Month',
      value: [
        dayjs().subtract(1, 'month').startOf('month'),
        dayjs().subtract(1, 'month').endOf('month'),
      ],
    },
  ];

  useEffect(() => {
    if (date_from && date_to) {
      setFormattedValue([dayjs(date_from), dayjs(date_to)]);
    } else {
      setFormattedValue([null, null]);
    }
  }, [date_from, date_to]);

  const onRangeChange = (dates, dateStrings) => {
    const formattedDates = dates ? dates.map((date) => date?.format('YYYY-MM-DD')) : [null, null];

    setDate({
      date_from: formattedDates[0],
      date_to: formattedDates[1],
      change_global: changeGlobal,
      date_key: date_key,
    });

    if (changeGlobal) {
      setUrlParams({ date_from: formattedDates[0], date_to: formattedDates[1] });
    }
  };

  return (
    <RangePicker
      size='small'
      format='MMM-DD'
      variant='filled'
      {...rest}
      value={formattedValue}
      className='!text-sm !font-semibold'
      presets={rangePresets}
      onChange={onRangeChange}
      suffixIcon={<Icon className='text-orange' path={mdiCalendarMonth} />}
      renderExtraFooter={() => (
        <Checkbox
          className='px-2 text-sm font-normal'
          onChange={(e) => setChangeGlobal(e.target.checked)}
          checked={changeGlobal}
        >
          Apply Globally
        </Checkbox>
      )}
    />
  );
};

export default RangePickerComponent;
